import React from 'react';

const MentalToughnessBookPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-100 to-yellow-100 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <img src="/Images/book-cover.png" alt="Book Cover" className="mx-auto mb-8 rounded-lg shadow-lg" />
            <h1 className="text-5xl font-bold text-green-800 mb-4">The Mental Toughness Guide</h1>
            <p className="text-2xl text-gray-700 mb-8">
              Tennis is 90% Mental. Are you training the 90%?
            </p>
          </div>
        </div>
      </section>

      {/* Format Selector */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-green-800 mb-12">Choose Your Format</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-green-50 p-8 rounded-lg shadow-md text-center">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Physical Copy</h3>
              <p className="text-gray-700 mb-6">For the bedside table/bag.</p>
              <a href="https://www.amazon.ca/dp/B0GDFC5JGP" target="_blank" rel="noopener noreferrer" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300 inline-block">
                Buy Physical
              </a>
            </div>
            <div className="bg-yellow-50 p-8 rounded-lg shadow-md text-center">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Digital (E-Book)</h3>
              <p className="text-gray-700 mb-6">Instant access on your phone.</p>
              <div className="space-y-2">
                <a href="https://www.amazon.ca/Tips-Improve-Mental-Toughness-Tennis-ebook/dp/B0GD9542LS/ref=tmm_kin_swatch_0" target="_blank" rel="noopener noreferrer" className="bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-2 px-4 rounded-md transition duration-300 inline-block">
                  Buy on Amazon
                </a>
                <br />
                <a href="https://play.google.com/store/books/details?id=x8muEQAAQBAJ" target="_blank" rel="noopener noreferrer" className="bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-2 px-4 rounded-md transition duration-300 inline-block">
                  Buy on Google Play
                </a>
              </div>
            </div>
            <div className="bg-green-50 p-8 rounded-lg shadow-md text-center">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Audiobook</h3>
              <p className="text-gray-700 mb-6">Listen on the way to the tournament.</p>
              <a href="https://open.spotify.com/show/1Fb5cyG5tZI1WcMyvPBusm" target="_blank" rel="noopener noreferrer" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300 inline-block">
                Buy Audio
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* What's Inside */}
      <section className="py-16 bg-gradient-to-r from-green-100 to-yellow-100">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-green-800 mb-12">What's Inside</h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 mb-8 text-center">
              Are you ready to take your tennis game to the next level? 10 Tips to Improve Mental Toughness in Tennis is your ultimate guide to developing the mental strength necessary to dominate on the court. This book is thoughtfully divided into two sections: five tips on things to focus on and five tips on important things to remember. These powerful and practical strategies will enhance your mental toughness, enabling you to stay focused, confident, and resilient under pressure.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-2xl font-semibold text-green-800 mb-4">Things to Focus On</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li><strong>Maintain Focus:</strong> Learn techniques to stay concentrated during intense matches and practice sessions.</li>
                  <li><strong>Build Confidence:</strong> Develop self-belief and positive thinking to approach each match with unwavering assurance.</li>
                  <li><strong>Handle Pressure:</strong> Master the art of staying calm and composed in high-stakes situations.</li>
                  <li><strong>Set Effective Goals:</strong> Create and achieve meaningful goals that keep you motivated and driven.</li>
                  <li><strong>Develop Resilience:</strong> Bounce back from setbacks and losses with a stronger mindset.</li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-2xl font-semibold text-green-800 mb-4">Important Things to Remember</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li><strong>Visualize Success:</strong> Harness the power of visualization to prepare mentally for every match.</li>
                  <li><strong>Control Emotions:</strong> Manage your emotions to maintain a clear and strategic mind.</li>
                  <li><strong>Stay Motivated:</strong> Find and sustain your inner drive to continuously improve your game.</li>
                  <li><strong>Improve Concentration:</strong> Strengthen your ability to stay present and focused on the court.</li>
                  <li><strong>Embrace Challenges:</strong> Turn obstacles into opportunities for growth and development.</li>
                </ul>
              </div>
            </div>
            <p className="text-lg text-gray-700 text-center">
              Whether you're a beginner or a seasoned player, 10 Tips to Improve Mental Toughness in Tennis will empower you to elevate your mental game and achieve peak performance. Get ready to unlock your full potential and become a mentally tough tennis champion!
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentalToughnessBookPage;

